import { render, staticRenderFns } from "./ConfigResetTa.vue?vue&type=template&id=1cf1b320&"
import script from "./ConfigResetTa.vue?vue&type=script&lang=js&"
export * from "./ConfigResetTa.vue?vue&type=script&lang=js&"
import style0 from "./ConfigResetTa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports